export const MOST_TIPPED = 1;
export const TOP_LEAGUES = 2;
export const SUPERTIP = 3;
export const FAVORIT_PLUS = 4;
export const PREMATCH = 5;



// WEBPACK FOOTER //
// ./src/HOCs/Constants/MostPlayedOptionID.js